export default class SurveyQuestionResponses {
  constructor(data) {
    if (!data) {
      data = [];
    }

    for(const d of data) {
        if(d.multiple_choice) 
            this[d.question.slug] = { 
                selections: d.multiple_choice.answer,
                follow_up: d.followup_answer
            }
        else if (d.free_text)
            this[d.question.slug] = d.free_text.answer
        else if (d.star_rating)
            this[d.question.slug] = d.star_rating.answer
        else {
            throw new Error("Unknown questionresponse type.")
        }
    }
  }
}
